import { t } from "../i18n";

export default function GuestPromptModal({
  lang,
  title,
  description,
  onSignIn,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden text-center">
        {/* Icon */}
        <div className="pt-10 pb-4 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </div>
        </div>

        {/* Text */}
        <div className="px-8 pb-2">
          <h2 className="text-xl font-bold text-gray-900 text-center">
            {title || t(lang, "guestPromptTitle")}
          </h2>
        </div>
        <div className="px-8 pb-6">
          <p className="text-sm text-gray-500 text-center leading-relaxed">
            {description || t(lang, "guestPromptDesc")}
          </p>
        </div>

        {/* Actions */}
        <div className="px-8 pb-8 flex flex-col gap-3">
          <button
            onClick={onSignIn}
            className="w-full py-3 px-4 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition"
          >
            {t(lang, "guestPromptCTA")}
          </button>
          <button
            onClick={onClose}
            className="w-full py-3 text-sm text-gray-500 hover:text-gray-700 transition"
          >
            {t(lang, "guestPromptListen")}
          </button>
        </div>
      </div>
    </div>
  );
}
